import { css, Styles, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  root: css`
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding: 24px;
    width: 100%;
    height: 100%;
  `,

  header: ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
    flex-direction: row;
    color: ${theme.colors.neutral.variant[70]};
  `,

  sparkle: ({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${theme.colors.neutral.variant[70]};
  `,

  dropArea: ({ theme }) => css`
    flex: 1;
    border: 2px dashed ${theme.colors.neutral.variant[30]};
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    background-color: ${theme.colors.neutral.variant[5]};

    &:hover {
      border-color: ${theme.colors.neutral.variant[50]};
      background-color: ${theme.colors.neutral.variant[10]};
    }
  `,

  dropAreaDragging: ({ theme }) => css`
    flex: 1;
    border-color: ${theme.colors.primary.fuchsia[50]};
    background-color: ${theme.colors.primary.fuchsia[10]};
  `,

  fileInput: css`
    display: none;
  `,

  fileInputLabel: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
    cursor: pointer;
    width: 100%;
    height: 100%;
  `,

  fileInfo: ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px;
    background-color: ${theme.colors.neutral.variant[20]};
    border-radius: 4px;
    width: calc(100% - 64px);
  `,

  removeButton: ({ theme }) => css`
    margin-left: auto;
    background: none;
    border: none;
    padding: 4px;
    cursor: pointer;
    color: ${theme.colors.neutral.variant[40]};
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      color: ${theme.colors.neutral.variant[70]};
    }
  `,

  submitButtonWrapper: css`
    display: flex;
    justify-content: flex-end;
    gap: 14px;
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
